module.exports = __webpack_public_path__ + "static/media/Galaxor_1920x1080.2fd167b2.png";